export const importOrdersConstants = {
  IMPORT_ORDERS: "Import Orders",
  IMPORT_ORDER_DATA: "IMPORT_ORDER_DATA",
  IMPORT_ORDER_SUCESSFULLY: "Import Order Successfully"
};
